import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { OnboardingLayout, OnboardingTask, OnboardingTheme, resolveModuleIcon, TaskCardVariant } from '../../interfaces/onboarding.interfaces';

/**
 * Tarjeta presentacional reutilizable de una tarea del onboarding. La variante visual (`completed` |
 * `next` | `pending`) y el `layout` (`vertical` Fase 1 | `horizontal` Fase 2) los decide el contenedor y
 * se reciben como `@Input` — la tarjeta no ramifica por `phase_id`. El ícono de módulo se deriva con
 * `resolveModuleIcon(task.module)`. Al hacer click emite la tarea y el contenedor navega.
 */
@Component({
    selector: 'fina-onboarding-task-card',
    templateUrl: './onboarding-task-card.component.html',
    styleUrls: ['./onboarding-task-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingTaskCardComponent {
    @Input() task!: OnboardingTask;
    @Input() variant: TaskCardVariant = 'pending';
    @Input() large = false;
    @Input() layout: OnboardingLayout = 'vertical';
    @Input() theme: OnboardingTheme = 'purple';
    @Output() cardClick = new EventEmitter<OnboardingTask>();

    get moduleIcon(): string {
        return resolveModuleIcon(this.task.module);
    }

    /** Texto del botón de acción (default "Ir"). */
    get actionLabel(): string {
        return this.task.action_label || 'Ir';
    }

    onClick(): void {
        this.cardClick.emit(this.task);
    }
}
